function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M84.945,143.118c0.658,0.178,1.32,0.264,1.971,0.264c3.301,0,6.326-2.197,7.234-5.537 c13.93-51.301,57.279-60.041,59.123-60.389c4.063-0.75,6.754-4.646,6.018-8.713c-0.74-4.074-4.643-6.785-8.719-6.043 c-2.213,0.402-54.418,10.525-70.898,71.213C78.588,137.911,80.949,142.032,84.945,143.118z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.451,155.935h-29.764c-2.537-33.875-17.166-65.354-41.664-89.266c-18.662-18.217-41.586-30.6-66.465-36.225 C212.566,15.112,199.432,3.23,183.564,3.23s-29.002,11.883-30.994,27.215c-24.879,5.627-47.803,18.008-66.465,36.225 c-24.498,23.912-39.127,55.391-41.664,89.266H14.678C6.584,155.935,0,162.519,0,170.61v15.824c0,8.092,6.584,14.676,14.678,14.676 h83.605c4.453,6.203,22.949,33.793,29.207,41.459c10.162,12.447,38.367,18.527,52.154,20.826l-10.422,92.158 c-0.467,4.115,2.492,7.83,6.609,8.295c0.285,0.033,0.57,0.049,0.851,0.049c3.764,0,7.01-2.828,7.443-6.658l11.238-99.361 c0.463-4.09-2.455-7.787-6.539-8.287c-16.723-2.051-43.201-8.527-49.717-16.508c-5.811-7.117-20.381-28.855-22.516-31.973h16.809 c4.129,3.721,13.578,12.021,24.623,20.303c7.859,5.896,40.809,5.162,58.072,0.199c1.695-0.486,3.164-1.555,4.148-3.02 l11.774-17.482h14.674l-17.1,59.254c-0.209,0.723-0.309,1.473-0.293,2.225l1.826,93.953c0.08,4.092,3.422,7.354,7.496,7.354 c0.049,0,0.1,0,0.148,0c4.141-0.082,7.434-3.504,7.354-7.645l-1.805-92.818l17.986-62.322h90.145 c8.092,0,14.676-6.584,14.676-14.676V170.61C367.127,162.519,360.543,155.935,352.451,155.935z M183.564,41.995 c65.473,0,118.568,49.293,124.07,113.578H59.494C64.996,91.288,118.092,41.995,183.564,41.995z M183.564,18.229 c6.572,0,12.232,3.924,14.795,9.547c-4.883-0.514-9.82-0.781-14.795-0.781s-9.912,0.268-14.797,0.781 C171.332,22.153,176.992,18.229,183.564,18.229z M209.385,207.87c-15.58,3.717-38.115,3.014-42.717,1.275 c-3.625-2.728-7.082-5.471-10.217-8.035h57.484L209.385,207.87z M352.127,186.11H15v-15.176h337.127V186.11z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgWeddingReception = function SvgWeddingReception(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 367.127 367.127",
    style: {
      enableBackground: "new 0 0 367.127 367.127"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeddingReception, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wedding-reception.68a9cff5.svg";
export { ForwardRef as ReactComponent };